export default __webpack_public_path__ + "static/media/CarePlus_Logo_.9a2c343a.jpg";